import {
	personIconMap,
	personPillMap,
} from '@dealstack/frontend/app/pages/Project/DocumentLibrary/SidePanels/RightPanel/utils';
import {
	DEAL_ROUTES,
	PEOPLE_ROUTES,
	ROUTES,
} from '@dealstack/frontend/app/pages/Routing/routes.ts';
import { FormFieldListValue } from '@dealstack/frontend/shared/components/Documents/FormFields/types';
import { constructTransactionSentence } from '@dealstack/frontend/shared/utils/constructTransactionSentence';
import {
	DocumentDetailsRes,
	DocumentFields,
	DocumentPersonRelationRes,
} from '@dealstack/shared/lib/generated';
import { generatePath } from 'react-router-dom';

interface MapValueToFieldArgs {
	fieldKey: keyof DocumentDetailsRes;
	relatedPeople: DocumentPersonRelationRes[];
	documentDetails: DocumentDetailsRes | undefined;
	dealId: string;
}

export const mapValueToField = ({
	fieldKey,
	relatedPeople,
	documentDetails,
	dealId,
}: MapValueToFieldArgs): FormFieldListValue[] | string => {
	if (fieldKey === DocumentFields.RELATED_PEOPLE) {
		return relatedPeople.map((person) => ({
			id: person.personId,
			value: person.personName,
			badge: personPillMap(person.documentPersonType) ?? undefined,
			icon: personIconMap(person.personType),
		}));
	}

	if (fieldKey === DocumentFields.ASSOCIATED_TRANSACTIONS) {
		const associatedTransactions = documentDetails?.associatedTransactions ?? [];

		return associatedTransactions.map((transaction) => ({
			id: transaction.transactionId,
			value: constructTransactionSentence(transaction),
			subText: `Transaction ID: ${transaction.transactionId}`,
			url: generatePath(
				`${ROUTES.DEAL}${DEAL_ROUTES.PEOPLE}${PEOPLE_ROUTES.TRANSACTION_DETAILS}`,
				{
					dealId,
					personId: transaction.issuerId,
					transactionId: transaction.transactionId,
				}
			),
			icon: 'money-v3',
		}));
	}

	return (documentDetails?.[fieldKey] as string) ?? '';
};
